var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { calcWidth, getNumColumns, isScreenDefined } from './utils';
var defaultMargin = 8;
export var Card = styled.div.withConfig({
  displayName: "Cards__Card",
  componentId: "sc-esqy7n-0"
})(["display:flex;flex:0 1 auto;box-sizing:border-box;margin:", "px;padding:", ";width:", ";border-radius:5px;background-color:", ";", " ", ";", ";"], defaultMargin, function (_ref) {
  var padding = _ref.padding;
  return "".concat(padding, "px");
}, function () {
  return "calc(".concat(calcWidth(1), "% - ").concat(defaultMargin * 2, "px)");
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, function (props) {
  return props.noVerticalMargin && css(["margin-bottom:0;margin-top:0;"]);
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (props) {
  return props.backgroundColor && css(["margin-bottom:5px;margin-top:5px;"]);
}), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: 12px;\n  "]))));
var StyledCards = styled.div.withConfig({
  displayName: "Cards__StyledCards",
  componentId: "sc-esqy7n-1"
})(["display:flex;flex-wrap:wrap;margin-left:", ";margin-right:", ";margin-top:", ";> div{width:", ";}> div{", ";", ";", ";", ";"], function () {
  return "-".concat(defaultMargin, "px");
}, function () {
  return "-".concat(defaultMargin, "px");
}, function () {
  return "-".concat(defaultMargin, "px");
}, function (props) {
  return "calc(".concat(calcWidth(getNumColumns(props.breakpoints, 'miniPhone', 1)), "% - ").concat(defaultMargin * 2, "px)");
}, minMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";"])), function (props) {
  return isScreenDefined(props.breakpoints, 'phone') ? "width: calc(".concat(calcWidth(getNumColumns(props.breakpoints, 'phone', 1)), "% - ").concat(defaultMargin * 2, "px)") : "";
}), minMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", ";"])), function (props) {
  return isScreenDefined(props.breakpoints, 'phablet') ? "width: calc(".concat(calcWidth(getNumColumns(props.breakpoints, 'phablet', 2)), "% - ").concat(defaultMargin * 2, "px)") : "";
}), minMediaQueries.tablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      ", ";"])), function (props) {
  return isScreenDefined(props.breakpoints, 'tablet') ? "width: calc(".concat(calcWidth(getNumColumns(props.breakpoints, 'tablet', 3)), "% - ").concat(defaultMargin * 2, "px)") : "";
}), minMediaQueries.desktop(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      ", ";"])), function (props) {
  return isScreenDefined(props.breakpoints, 'desktop') ? "width: calc(".concat(calcWidth(getNumColumns(props.breakpoints, 'desktop', 4)), "% - ").concat(defaultMargin * 2, "px)") : "";
}));
var defaultColumnsBreakpoints = [{
  screen: 'miniPhone',
  columns: 1
}, {
  screen: 'phone',
  columns: 1
}, {
  screen: 'phablet',
  columns: 2
}, {
  screen: 'tablet',
  columns: 4
}, {
  screen: 'miniDesktop',
  columns: 4
}, {
  screen: 'desktop',
  columns: 4
}, {
  screen: 'bigScreen',
  columns: 4
}];
export var Cards = function Cards(props) {
  var styledBreakpoints = props.breakpoints ? props.breakpoints : defaultColumnsBreakpoints;
  return React.createElement(StyledCards, {
    breakpoints: styledBreakpoints
  }, props.children);
};